import Vue from "vue";
import Vuex from "vuex";
import {
  coreInstance,
  backendVersion,
  resolveBackendUrl,
} from "@/axios-path";
import VuexPersistence from "vuex-persist";
import router from "./../router";
import modules from "./ModulesImport";
Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    acctoken: state.acctoken,
    Info: state.Info,
    role: state.role,
    user_name: state.user_name,
    permission: state.permission,
    // user_id: state.storePos.user_id,
    // province: state.provincePos.province,
    // store_id: state.storePos.store_id
  }),
});

export const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    ...modules,
  },
  state: {
    api_urls: {},
    authInfo: null,
    role: "guest",
    permission_list: [
      {
        permission_id: 1,
        permission_name: "SuperAdmin",
        province: [],
        order: {
          edit_view: 2,
        },
        order_dine_in: { edit_view: 2, },
        order_wesmart: {
          edit_view: 2,
        },
        store_and_product: {
          store_list: 2,
          product_list: 2,
          order_store_review: 2,
        },
        food: {
          package_list: 2,
          transfer_list: 2,
          set_free_price_round: 2,
          campaign_distance: 2,
          base_distance: 2,
          small_order_difference: 2,
          food_add_on: 2
        },
        rider: {
          rider_list: {
            rider_user: 2,
            rider_approve: 2,
          },
          rider_money: {
            rider_wallet: 2,
            rider_request: 2,
            rider_withdraw: 2,
            rider_refill: 2,
          },
          rider_commission: {
            rider_deposit_commission: 2,
            rider_withdraw_commission: 2,
            rider_penalty: 2,
          },
          rider_setting: {
            rider_bank: 2,
          },
        },
        report: {
          summary: {
            order_report: 2,
            promotion_report: 2,
            customer_report: 2,
          },
          free_food: {
            store_report: 2,
            store_payment: 2,
          },
          messenger: {
            sale_messenger: 2,
          },
          rider: {
            rider_user_report: 2,
            extra_credit_report: 2,
          },
          order_receipt: {
            food_delivery_receipt: 2,
            free_delivery_receipt: 2,
            messenger_receipt: 2,
          },
          hotel_service: {
            hotel_order_report: 2
          }
        },
        messenger: {
          contract: 2,
          addon: 2,
          vehicle: 2,
        },
        main_menu: {
          tracking_rider: 2,
          transfer_token_queue: 2,
          app_campaign_reward: 2,
          campaign_crypto: 2,
          dine_in_management: {
            manage_list: {
              store_manage: 2,
              store_type_manage: 2,
              store_category_manage: 2,
            },
            create_list: {
              create_store: 2,
              create_store_type: 2,
            },
            setting_list: {
              district_setting: 2,
            },
            review_list: {
              store_review_manage: 2,
              review_benefit: 2
            }
          },
          merchant_manage: {
            approve_list: {
              contact_approve: 2,
              store_approve: 2,
              store_edit_approve: 2,
              document_approve: 2,
              product_approve: 2,
              approve_log: 2,
              store_status: 2,
              event_log: 2,
            },
            dine_in_merchant: {
              store_manage_user: 2,
            },
            user_list: {
              edit_view: 2,
            },
            notification: {
              merchant_news: 2,
            },
          },

          report_dashboard: {
            main: {
              report_reward: 2,
              packages_report: 2,
              connect_wallet_report: 2,
              wellness_report: 2,
              order_dineIn_report: 2,
            },
            food: {},
            mess: {},
          },
          promotion_manage: {
            promotion_list: 2,
          },
          find_user_otp: 2,
          customer_manage: 2,
          manage_staff: 2,
          manager_manage: 2,
          app_maintance: 2,
          app_notificaition: 2,
          service_manage: 2,
          point_manage: 2,
          tier_benefits_manage: 2,
          weserve_ads: 2,
          hotel_service: {
            hotel_manage: 2,
          },
          // financial permission
          rider_request_cash: 2,
          weserve_card_payment_refund: 2,
          transfer_merchant_credit: 2
        },
        app_setting: {
          edit_view: 2,
        },
      },
      {
        permission_id: 2,
        permission_name: "Marketing",
        province: [],
        order: {
          edit_view: 2,
        },
        order_dine_in: { edit_view: 2, },
        order_wesmart: {
          edit_view: 2,
        },
        store_and_product: {
          store_list: 2,
          product_list: 2,
          approve_list: 2,
          order_store_review: 2,
        },
        rider: {},
        report: {
          summary: {
            order_report: 2,
            promotion_report: 2,
            customer_report: 2,
          },
          free_food: {
            store_report: 2,
            store_payment: 2,
          },
          messenger: {
            sale_messenger: 2,
          },
          rider: {
            rider_user_report: 1,
            extra_credit_report: 2,
          },
          order_receipt: {
            food_delivery_receipt: 2,
            free_delivery_receipt: 2,
            messenger_receipt: 2,
          },
        },
        messenger: {
          contract: 2,
          addon: 2,
          vehicle: 2,
        },
        main_menu: {
          promotion_manage: {
            promotion_list: 2,
          },
          report_dashboard: {
            main: {
              report_reward: 2,
              packages_report: 2,
              connect_wallet_report: 2,
              wellness_report: 2,
              order_dineIn_report: 2,
            },
            food: {},
            mess: {},
          },
          customer_manage: 2,
          app_maintance: 2,
          app_notificaition: 2,
          manager_manage: 2,
        },
        app_setting: {
          edit_view: 2,
        },
      },
      {
        permission_id: 3,
        permission_name: "Callcenter",
        province: [],
        order: {
          edit_view: 2,
        },
        order_dine_in: { edit_view: 2, },
        order_wesmart: {
          edit_view: 2,
        },
        store_and_product: {
          store_list: 2,
          product_list: 2,
          approve_list: 2,
          order_store_review: 2,
        },
        food: {},
        rider: {},
        report: {
          summary: {
            customer_report: 2,
            order_report: 2,
          },
          messenger: {
            sale_messenger: 2,
          },
          order_receipt: {
            food_delivery_receipt: 2,
            free_delivery_receipt: 2,
            messenger_receipt: 2,
          },
        },
        messenger: {
          contract: 2,
        },
        main_menu: {
          tracking_rider: 2,
          find_user_otp: 2,
          customer_manage: 2,
          dine_in_management: {
            manage_list: {
              store_manage: 2,
              store_type_manage: 2,
              store_category_manage: 2,
              store_review_manage: 2,
            },
            create_list: {
              create_store: 2,
              create_store_type: 2,
            },
            setting_list: {
              district_setting: 2,
            },
          },
        },
        app_setting: {
          edit_view: 2,
        },
      },
      {
        permission_id: 4,
        permission_name: "Admin",
        province: [],
        order: {},
        order_dine_in: {},
        order_wesmart: {},
        store_and_product: {
          store_list: 2,
          product_list: 2,
          approve_list: 2,
          order_store_review: 2,
        },
        food: {
          package_list: 2,
        },
        rider: {},
        report: {
          summary: {
            order_report: 2,
            promotion_report: 2,
            customer_report: 2,
          },
          free_food: {
            store_report: 2,
            store_payment: 2,
          },
          messenger: {
            sale_messenger: 2,
          },
          rider: {
            rider_user_report: 2,
            extra_credit_report: 2,
          },
          order_receipt: {
            food_delivery_receipt: 2,
            free_delivery_receipt: 2,
            messenger_receipt: 2,
          },
        },
        messenger: {},
        main_menu: {
          customer_manage: 2,
          app_maintance: 2,
          app_notificaition: 2,
          manager_manage: 2,
          dine_in_management: {
            manage_list: {
              store_manage: 2,
              store_type_manage: 2,
              store_category_manage: 2,
            },
            create_list: {
              create_store: 2,
              create_store_type: 2,
            },
            setting_list: {
              district_setting: 2,
            },
            review_list: {
              store_review_manage: 2,
            }
          },
        },
        app_setting: {
          // edit_view: 2
        },
      },
      {
        permission_id: 5,
        permission_name: "Accounting",
        province: [],
        order: {
          edit_view: 2,
        },
        order_dine_in: { edit_view: 2, },
        order_wesmart: {},
        store_and_product: {},
        food: {},
        rider: {
          rider_list: {
            rider_user: 2,
            rider_approve: 2,
          },
          rider_money: {
            rider_wallet: 2,
            rider_request: 2,
            rider_withdraw: 2,
            rider_refill: 2,
          },
          rider_commission: {
            rider_deposit_commission: 2,
            rider_withdraw_commission: 2,
            rider_penalty: 2,
          },
          rider_setting: {
            rider_bank: 2,
          },
        },
        report: {
          summary: {
            order_report: 2,
            promotion_report: 2,
            customer_report: 2,
          },
          free_food: {
            store_report: 2,
            store_payment: 2,
          },
          messenger: {
            sale_messenger: 2,
          },
          rider: {
            rider_user_report: 2,
            extra_credit_report: 2,
          },
          order_receipt: {
            food_delivery_receipt: 2,
            free_delivery_receipt: 2,
            messenger_receipt: 2,
          },
        },
        messenger: {
          contract: 2,
        },
        main_menu: {
          report_dashboard: {
            main: {
              report_reward: 2,
              packages_report: 2,
              connect_wallet_report: 2,
              wellness_report: 2,
              order_dineIn_report: 2,
            },
            food: {},
            mess: {},
          },
          manager_manage: 2,
          // financial permission
          rider_request_cash: 2,
          weserve_card_payment_refund: 2,
          transfer_merchant_credit: 2
        },
        app_setting: {
          // edit_view: 2
        },
      },
      {
        permission_id: 6,
        permission_name: "Viewer(Manager)",
        province: [],
        order: {
          edit_view: 1,
        },
        order_wesmart: {},
        store_and_product: {
          store_list: 1,
          product_list: 1,
          approve_list: 1,
          order_store_review: 1,
        },
        food: {},
        rider: {
          rider_list: {
            rider_user: 1,
          },
          rider_money: {
            rider_wallet: 1,
          },
          rider_commission: {
            rider_deposit_commission: 2,
            rider_withdraw_commission: 2,
          },
        },
        report: {
          summary: {
            order_report: 2,
          },
          rider: {
            rider_user_report: 2,
          },
        },
        messenger: {},
        main_menu: {},
        app_setting: {},
      },
      {
        permission_id: 7,
        permission_name: "AdminLaborStore",
        province: [],
        order: {},
        order_dine_in: {},
        order_wesmart: {},
        store_and_product: {
          store_list: 2,
          product_list: 2,
          approve_list: 2,
          order_store_review: 2,
        },
        food: {},
        rider: {},
        report: {},
        messenger: {},
        main_menu: {},
        app_setting: {},
      },
      {
        permission_id: 8,
        permission_name: "RiderManager",
        province: [],
        order: {
          edit_view: 2,
        },
        order_dine_in: { edit_view: 2, },
        order_wesmart: {
          edit_view: 2,
        },
        store_and_product: {},
        food: {
          transfer_list: 2,
          set_free_price_round: 2,
        },
        rider: {
          rider_list: {
            rider_user: 2,
            rider_approve: 2,
          },
          rider_money: {
            rider_wallet: 2,
            rider_request: 2,
            rider_withdraw: 2,
            rider_refill: 2,
          },
          rider_commission: {
            rider_deposit_commission: 2,
            rider_withdraw_commission: 2,
            rider_penalty: 2,
          },
          rider_setting: {
            rider_bank: 2,
          },
        },
        report: {
          summary: {
            order_report: 2,
            promotion_report: 2,
            customer_report: 2,
          },
          free_food: {
            store_report: 2,
            store_payment: 2,
          },
          messenger: {
            sale_messenger: 2,
          },
          rider: {
            rider_user_report: 2,
            extra_credit_report: 2,
          },
          order_receipt: {
            food_delivery_receipt: 2,
            free_delivery_receipt: 2,
            messenger_receipt: 2,
          },
        },
        messenger: {
          addon: 2,
          vehicle: 2,
        },
        main_menu: {
          // financial permission
          rider_request_cash: 2,
        },
        app_setting: {},
      },
      {
        permission_id: 9,
        permission_name: "Root",
        province: [],
        order: {
          edit_view: 3,
        },
        order_wesmart: {
          edit_view: 3,
        },
        store_and_product: {
          store_list: 2,
          product_list: 2,
          order_store_review: 2,
        },
        food: {
          package_list: 2,
          transfer_list: 2,
          set_free_price_round: 2,
          campaign_distance: 2,
          base_distance: 2,
          small_order_difference: 2,
          food_add_on: 2
        },
        rider: {
          rider_list: {
            rider_user: 2,
            rider_approve: 2,
          },
          rider_money: {
            rider_wallet: 2,
            rider_request: 2,
            rider_withdraw: 2,
            rider_refill: 2,
          },
          rider_commission: {
            rider_deposit_commission: 2,
            rider_withdraw_commission: 2,
            rider_penalty: 2,
          },
          rider_setting: {
            rider_bank: 2,
          },
        },
        report: {
          summary: {
            order_report: 2,
            promotion_report: 2,
            customer_report: 2,
          },
          free_food: {
            store_report: 2,
            store_payment: 2,
          },
          messenger: {
            sale_messenger: 2,
          },
          rider: {
            rider_user_report: 2,
            extra_credit_report: 2,
          },
          order_receipt: {
            food_delivery_receipt: 2,
            free_delivery_receipt: 2,
            messenger_receipt: 2,
          },
          hotel_service: {
            hotel_order_report: 2
          }
        },
        messenger: {
          contract: 2,
          addon: 2,
          vehicle: 2,
        },
        main_menu: {
          tracking_rider: 2,
          promotion_manage: {
            promotion_list: 2,
          },
          transfer_token_queue: 2,
          app_campaign_reward: 2,
          campaign_crypto: 2,
          dine_in_management: {
            manage_list: {
              store_manage: 2,
              store_type_manage: 2,
              store_category_manage: 2,
            },
            create_list: {
              create_store: 2,
              create_store_type: 2,
            },
            setting_list: {
              district_setting: 2,
            },
            review_list: {
              store_review_manage: 2,
              review_benefit: 2
            }
          },
          merchant_manage: {
            approve_list: {
              contact_approve: 2,
              store_approve: 2,
              store_edit_approve: 2,
              document_approve: 2,
              product_approve: 2,
              approve_log: 2,
              store_status: 2,
              event_log: 2,
            },
            dine_in_merchant: {
              store_manage_user: 2,
            },
            user_list: {
              edit_view: 2,
            },
            notification: {
              merchant_news: 2,
            },
          },
          report_dashboard: {
            main: {
              report_reward: 2,
              packages_report: 2,
              connect_wallet_report: 2,
              wellness_report: 2,
              order_dineIn_report: 2,
            },
            food: {},
            mess: {},
          },
          find_user_otp: 2,
          customer_manage: 2,
          manage_staff: 2,
          manager_manage: 2,
          app_maintance: 2,
          app_notificaition: 2,
          service_manage: 2,
          point_manage: 2,
          tier_benefits_manage: 2,
          weserve_ads: 2,
          hotel_service: {
            hotel_manage: 2,
          },
          // financial permission
          rider_request_cash: 2,
          weserve_card_payment_refund: 2,
          transfer_merchant_credit: 2
        },
        app_setting: {
          edit_view: 2,
        },
      },
      {
        permission_id: 10,
        permission_name: "CallCenterAdmin",
        province: [],
        order: {
          edit_view: 2,
        },
        order_dine_in: { edit_view: 2, },
        order_wesmart: {
          edit_view: 2,
        },
        store_and_product: {
          store_list: 2,
          product_list: 2,
          approve_list: 2,
          order_store_review: 2,
        },
        food: {},
        rider: {},
        report: {
          summary: {
            customer_report: 2,
            order_report: 2,
          },
          messenger: {
            sale_messenger: 2,
          },
          order_receipt: {
            food_delivery_receipt: 2,
            free_delivery_receipt: 2,
            messenger_receipt: 2,
          },
        },
        messenger: {
          contract: 2,
        },
        main_menu: {
          tracking_rider: 2,
          find_user_otp: 2,
          customer_manage: 2,
          dine_in_management: {
            manage_list: {
              store_manage: 2,
              store_type_manage: 2,
              store_category_manage: 2,
              store_review_manage: 2,
            },
            create_list: {
              create_store: 2,
              create_store_type: 2,
            },
            setting_list: {
              district_setting: 2,
            },
          },
          merchant_manage: {
            approve_list: {
              contact_approve: 2,
              store_approve: 2,
              store_edit_approve: 2,
              document_approve: 2,
              product_approve: 2,
              approve_log: 2,
              store_status: 2,
              event_log: 2,
            },
            dine_in_merchant: {
              store_manage_user: 2,
            },
            user_list: {
              edit_view: 2,
            },
            notification: {
              merchant_news: 2,
            },
          },
        },
        app_setting: {
          edit_view: 2,
        },
      },
      ,
    ],
    permission: {},
    acctoken: null,
    regisLoading: "Not registing",
    disconnect: false,
    alerted: false,
    locale: "th",
    user_name: null,
  },
  mutations: {
    setLang(state, locale) {
      state.locale = locale;
    },
    login(state, { data, headers }) {
      if (headers.user_role) {
        for (let val of state.permission_list) {
          if (headers.user_role == val.permission_name) {
            state.permission = val;
            state.permission.province = data.user_province;
          }
        }
      } else {
        for (let val of state.permission_list) {
          if (data.user_role == val.permission_name) {
            state.permission = val;
            state.permission.province = data.user_province;
            break;
          }
        }
      }
      state.role = state.permission.permission_name;
      state.Info = data;
      state.acctoken = data.token;
      state.user_name = data.user_first_name;
    },
    logout(state) {
      state.Info = null;
      state.role = "guest";
      state.acctoken = null;
      state.fetchProvinceBack.provinceData = [];
      state.backOffice.province = null;
      state.backOffice.selectedMenu = "Back office menu";
      state.backOffice.service = null;
      state.permission = {}
      state.user_name = null;
      state.backOffice.recentRoutePath = [
        {
          text: "Select province",
          disabled: true,
          href: "/weserve_admin_login/select/",
        },
      ];
    },
    setDisconnect(state, boo) {
      state.disconnect = boo;
    },
    getAPIList(state, data) {
      state.api_urls = data;
    },
  },
  actions: {
    async sortData({ }, send_json_data) {
      let a = [];
      for (let key in send_json_data.data) {
        if (
          send_json_data.data[key].no_default &&
          key > 0 &&
          send_json_data.data[key].no_default ==
          send_json_data.data[key - 1].no_default
        ) {
          send_json_data.data[key][send_json_data.field] =
            send_json_data.data[key - 1][send_json_data.field];
          a.push(send_json_data.data[key]);
        }
      }
      send_json_data.data.sort(function (a, b) {
        let nameA = a[send_json_data.field];
        if (typeof nameA == "string") {
          nameA = nameA.toUpperCase();
        }
        let nameB = b[send_json_data.field];
        if (typeof nameB == "string") {
          nameB = nameB.toUpperCase();
        }
        if (nameA === nameB) {
          return 0;
        } else if (nameA === null) {
          return 1;
        } else if (nameB === null) {
          return -1;
        } else if (send_json_data.asc_desc == "asc") {
          return nameA < nameB ? -1 : 1;
        } else {
          return nameA < nameB ? 1 : -1;
        }
      });
      if (send_json_data.field != "no_default") {
        for (let key in send_json_data.data) {
          for (let val of a) {
            if (key == send_json_data.data.indexOf(val)) {
              send_json_data.data[key][send_json_data.field] = null;
            }
          }
        }
      }
      let count_no = 1;
      for (let key in send_json_data.data) {
        if (send_json_data.data[key].no) {
          send_json_data.data[key].no = count_no++;
        }
      }

      return send_json_data.data;
    },
    resetState({ commit }) {
      commit("fetchStorePaymentReport/resetState");
      commit("fetchSaleStoreReport/resetState");
      commit("fetchSaleMessengerReport/resetState");
      commit("fetchRiderReport/resetState");
      commit("fetchPromotionReport/resetState");
      commit("fetchReportDashboard/resetState");
      commit("fetchReportMessenger/resetState");
      commit("fetchReportFood/resetState");
      commit("fetchExtraCreditReport/resetState");
      commit("fetchFoodZoneBack/resetState");
      commit("fetchFoodRateBack/resetState");
      commit("fetchCashRider/resetState");
      commit("fetchRiderListBack/resetState");
      commit("fetchFoodSetAppBack/resetState");
      commit("fetchFoodPromotionBack/resetState");
      commit("fetchStoreBack/resetState");
      commit("fetchMessAddonBack/resetState");
      commit("fetchMessVehicleBack/resetState");
    },
    splitTemp({ }, clone_obj) {
      for (let obj in clone_obj) {
        let arr_split = obj.split("_");
        if (arr_split[arr_split.length - 1] == "temp") {
          delete clone_obj[obj];
        }
      }
      return clone_obj;
    },
    checkMessage({ state, dispatch }, msg) {
      if (state.alerted == false) {
        if (msg == 1) {
          alert("เชสชันหมดอายุ กรุณาล็อคอินใหม่");
          state.alerted = true;
          dispatch("logout");
        } else if (msg == 2) {
          alert("ระบบผิดพลาด");
          state.alerted = true;
          dispatch("logout");
        } else if (msg == 3) {
          alert("ไม่สามารถลบได้");
        } else if (msg == 4) {
          alert("เสร็จสิ้น");
        } else if (msg == 5) {
          alert("ชื่อผู้ใช้หรืออีเมลผิด");
        } else if (msg == 6) {
          alert("รหัสผ่านผิด");
        } else if (msg == 7) {
          alert("รหัสผ่านไม่ตรงกัน");
        } else if (msg == 8) {
          alert("มีข้อมูลอยู่ในระบบ");
        } else if (msg == 9) {
          alert(
            "ไม่สามารถเข้าใช้งาน Point of sale ได้ เนื่องจากรอการอนุมัติจากทางบริษัท"
          );
          dispatch("logout");
        }
      }
    },
    getAPIList({ commit }, province) {
      return coreInstance
        .get(
          backendVersion.version +
          "/service/GetServiceDiscovery/" +
          province +
          "/web_back_office"
        )
        .then((res) => {
          const apiUrls = Object.keys(res.data).reduce((urls, key) => {
            urls[key] = resolveBackendUrl(res.data[key]);
            return urls;
          }, {});
          commit("getAPIList", apiUrls);
        })
        .catch((err) => { });
    },
    disconnectNetwork({ state, commit, dispatch }, err) {
      if (err.message == "Network Error") {
        if (state.disconnect == false) {
          commit("setDisconnect", true);
          let myVar = setInterval(function () {
            const axiosConfig = {
              headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem("token"),
              },
            };
            return coreInstance
              .get(backendVersion.version + "/CheckConnect", axiosConfig)
              .then((res) => {
                if (res.msg === false) return;
                commit("setDisconnect", false);
                clearInterval(myVar);
                dispatch("fetchProvinceBack/getData", null, {
                  root: true,
                });
                return;
              })
              .catch((err) => {
                return;
              });
          }, 3000);
        }
      }
    },
    logout({ commit }, err) {
      commit("logout");
      localStorage.clear();
      router.replace("/weserve_admin_login");
    },
    login({ commit, dispatch, state }, authData) {
      return coreInstance
        .post(backendVersion.version + "/login", authData)
        .then((res) => {
          if (res.data.msg) {
            dispatch("checkMessage", res.data.msg);
            return false;
          } else {
            localStorage.setItem("token", res.data.token);
            state.alerted = false;
            if (
              res.data.user_role.toLowerCase() == "customer" ||
              res.data.user_role.toLowerCase() == "guest"
            ) {
              dispatch("logout");
              alert("ขออภัย คุณยังไม่มีคุณสมบัติให้เข้าใช้งานครับ/ค่ะ");
              return false;
            }

            commit("login", {
              data: res.data,
              headers: res.headers,
            });
            router.replace("/weserve_admin_login/select");
            return true;
          }
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, {
            root: true,
          });
          if (err != "Error: Network Error") {
            if (err.response.status == 400) {
              alert("อีเมล/เบอร์โทร หรือ รหัสผ่านผิดพลาด");
            } else {
              alert("ไม่สามารถเข้าสู่ระบบได้");
            }
          } else {
            alert("ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้");
          }
          return false;
        });
    },
  },
  getters: {
    isAuth(state) {
      return state.acctoken != null;
    },
    isEditOrder(state) {
      if (!state.permission.order.edit_view) {
        return true;
      }
      return state.permission.order.edit_view == 1 ? true : false;
    },
    isEditPromotion(state) {
      return (state.permission.main_menu.promotion_manage.promotion_list && state.permission.main_menu.promotion_manage.promotion_list == 2) ? false : true
    },
    isEditPackage(state) {
      if (!state.permission.food.package_list) {
        return true;
      }
      return state.permission.food.package_list == 1 ? true : false;
    },
    isEditTransfer(state) {
      if (!state.permission.food.transfer_list) {
        return true;
      }
      return state.permission.food.transfer_list == 1 ? true : false;
    },
    isEditPriceRound(state) {
      if (!state.permission.food.set_free_price_round) {
        return true;
      }
      return state.permission.food.set_free_price_round == 1 ? true : false;
    },
    isEditRiderSetting(state) {
      if (!state.permission.rider.rider_setting.rider_bank) {
        return true;
      }
      return state.permission.rider.rider_setting.rider_bank == 1
        ? true
        : false;
    },
    isEditStoreList(state) {
      if (!state.permission.store_and_product.store_list) {
        return true;
      }
      return state.permission.store_and_product.store_list == 1 ? true : false;
    },
    isEditProductList(state) {
      if (!state.permission.store_and_product.product_list) {
        return true;
      }
      return state.permission.store_and_product.product_list == 1
        ? true
        : false;
    },
    isEditStoreApprove(state) {
      if (
        !store.state.permission.main_menu.merchant_manage.approve_list
          .store_edit_approve
      ) {
        return true;
      }
      return store.state.permission.main_menu.merchant_manage.approve_list
        .store_edit_approve == 1
        ? true
        : false;
    },
    isEditDocumentApprove(state) {
      if (
        !store.state.permission.main_menu.merchant_manage.approve_list
          .document_approve
      ) {
        return true;
      }
      return store.state.permission.main_menu.merchant_manage.approve_list
        .document_approve == 1
        ? true
        : false;
    },
    isEditProductApprove(state) {
      if (
        !store.state.permission.main_menu.merchant_manage.approve_list
          .product_approve
      ) {
        return true;
      }
      return store.state.permission.main_menu.merchant_manage.approve_list
        .product_approve == 1
        ? true
        : false;
    },
    isEditDineInStore(state) {
      if (
        !store.state.permission.main_menu.dine_in_management.manage_list
          .store_manage
      ) {
        return true;
      }
      return store.state.permission.main_menu.dine_in_management.manage_list
        .store_manage == 1
        ? true
        : false;
    },
    isEditAddon(state) {
      if (!state.permission.messenger.addon) {
        return true;
      }
      return state.permission.messenger.addon == 1 ? true : false;
    },
    isEditVehicle(state) {
      if (!state.permission.messenger.vehicle) {
        return true;
      }
      return state.permission.messenger.vehicle == 1 ? true : false;
    },
    isEditCustomer(state) {
      if (!state.permission.main_menu.customer_manage) {
        return true;
      }
      return state.permission.main_menu.customer_manage == 1 ? true : false;
    },
    isEditStaff(state) {
      if (!state.permission.main_menu.manage_staff) {
        return true;
      }
      return state.permission.main_menu.manage_staff == 1 ? true : false;
    },
    isEditMaintance(state) {
      if (!state.permission.main_menu.app_maintance) {
        return true;
      }
      return state.permission.main_menu.app_maintance == 1 ? true : false;
    },
    isEditNotificaion(state) {
      if (!state.permission.main_menu.app_notificaition) {
        return true;
      }
      return state.permission.main_menu.app_notificaition == 1 ? true : false;
    },
  },
});
